import { render, staticRenderFns } from "./DailyProductsCustomers.vue?vue&type=template&id=101d6577"
import script from "./DailyProductsCustomers.vue?vue&type=script&lang=js"
export * from "./DailyProductsCustomers.vue?vue&type=script&lang=js"
import style0 from "./DailyProductsCustomers.vue?vue&type=style&index=0&id=101d6577&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports